import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from '../Header';
import Footer from '../Footer';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('announcements');
  const [announcements, setAnnouncements] = useState([]);
  const [events, setEvents] = useState([]);
  const [newAnnouncement, setNewAnnouncement] = useState('');
  const [newEvent, setNewEvent] = useState({ description: '', date: '' });
  const [updateData, setUpdateData] = useState({ class: '', type: '', link: '' });
  const [statusMessage, setStatusMessage] = useState('');
  const [password, setPassword] = useState(''); // Password state
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Auth state
  const [admissions, setAdmissions] = useState([]); // Store admission enquiries
  const [resultLink, setResultLink] = useState('');
  const predefinedPassword = 'Jni786';

  useEffect(() => {
    if (isAuthenticated) fetchData();
  }, [isAuthenticated]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [annRes, evtRes, admRes] = await Promise.all([
        axios.get('https://backend-school-914b.onrender.com/announcements'),
        axios.get('https://backend-school-914b.onrender.com/events'),
        axios.get('https://backend-school-914b.onrender.com/admissions'), // Fetching admissions data
        axios.get('https://backend-school-914b.onrender.com/result'), 
      ]);
      setAnnouncements(annRes.data);
      setEvents(evtRes.data);
      setAdmissions(admRes.data); 
      if (resultRes.data) {
        setResultLink(resultRes.data.link);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const handleLogin = () => {
    if (password === predefinedPassword) {
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password! Please try again.');
    }
  };

  const handleAddAnnouncement = async () => {
    try {
      const res = await axios.post('https://backend-school-914b.onrender.com/admin/announcement', { text: newAnnouncement });
      setAnnouncements([res.data, ...announcements]);
      setNewAnnouncement('');
    } catch (err) {
      console.error('Error adding announcement:', err);
    }
  };

  const handleDeleteAnnouncement = async (id) => {
    try {
      await axios.delete(`https://backend-school-914b.onrender.com/admin/announcement/${id}`);
      setAnnouncements(announcements.filter((ann) => ann._id !== id));
    } catch (err) {
      console.error('Error deleting announcement:', err);
    }
  };

  const handleAddEvent = async () => {
    try {
      const res = await axios.post('https://backend-school-914b.onrender.com/admin/event', newEvent);
      setEvents([...events, res.data]);
      setNewEvent({ description: '', date: '' });
    } catch (err) {
      console.error('Error adding event:', err);
    }
  };

  const handleDeleteEvent = async (id) => {
    try {
      await axios.delete(`https://backend-school-914b.onrender.com/admin/event/${id}`);
      setEvents(events.filter((evt) => evt._id !== id));
    } catch (err) {
      console.error('Error deleting event:', err);
    }
  };

  const handleUpdateResultLink = async () => {
    if (!resultLink) {
      alert('Please enter a result link');
      return;
    }

    try {
      const res = await axios.put('https://backend-school-914b.onrender.com/admin/result', { link: resultLink });
      alert('Result link updated successfully');
      setResultLink(res.data.link);
    } catch (err) {
      console.error('Error updating result link:', err);
      alert('Failed to update result link');
    }
  };

  const handleUpdateLink = async () => {
    if (!updateData.class || !updateData.type || !updateData.link) {
      alert('Please fill in all fields');
      return;
    }

    const endpoint =
      updateData.type === 'syllabus'
        ? 'https://backend-school-914b.onrender.com/admin/syllabus'
        : 'https://backend-school-914b.onrender.com/admin/timetable';

    try {
      await axios.post(endpoint, {
        class: updateData.class,
        downloadLink: updateData.link,
      });
      setStatusMessage('Update successful!');
      setUpdateData({ class: '', type: '', link: '' });
    } catch (err) {
      console.error('Error updating link:', err);
      setStatusMessage('Update failed.');
    }
  };

  return (
    <div>
      <style>
      {`
        .login-screen {
          max-width: 400px;
          margin: 50px auto;
          padding: 20px;
          border: 1px solid #ccc;
          border-radius: 8px;
          background-color: #f9f9f9;
          text-align: center;
        }
        .login-screen input {
          margin: 10px 0;
          padding: 10px;
          width: calc(100% - 20px);
          border: 1px solid #ccc;
          border-radius: 4px;
        }
        .login-screen button {
          padding: 10px 20px;
          border: none;
          border-radius: 4px;
          background-color: #007bff;
          color: #fff;
          cursor: pointer;
        }
        .login-screen button:hover {
          background-color: #0056b3;
        }
        .admin-panel {
          max-width: 900px;
          margin: 20px auto;
          padding: 20px;
          border: 1px solid #ccc;
          border-radius: 8px;
          background-color: #f9f9f9;
        }
        .admin-title {
          font-size: 24px;
          margin-bottom: 20px;
          text-align: center;
        }
        .tab-menu {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin-bottom: 20px;
        }
        .tab-menu button {
          padding: 10px 20px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          background-color: #007bff;
          color: #fff;
        }
        .tab-menu button.active {
          background-color: #0056b3;
        }
        section {
          margin-top: 20px;
        }
        section input,
        section select {
          margin-right: 10px;
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
          width: 100%;
          box-sizing: border-box;
          min-width: 150px;
        }
        section textarea {
          margin-right: 10px;
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
          width: 100%;
          box-sizing: border-box;
          min-width: 150px;
          resize: both;
          max-width: 100%;
        }
        section button {
          padding: 8px 16px;
          border: none;
          border-radius: 4px;
          background-color: #28a745;
          color: #fff;
          cursor: pointer;
        }
        section button:hover {
          background-color: #218838;
        }
        .chips {
          margin-top: 20px;
        }
        .chip {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          margin-bottom: 10px;
          background-color: #e9ecef;
          border-radius: 4px;
        }
        .chip button {
          padding: 4px 8px;
          border: none;
          border-radius: 4px;
          background-color: #dc3545;
          color: #fff;
          cursor: pointer;
        }
        .chip button:hover {
          background-color: #c82333;
        }
        .enquiry-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        .enquiry-table th,
        .enquiry-table td {
          padding: 10px;
          text-align: left;
          border: 1px solid #ddd;
        }
        .enquiry-table th {
          background-color: #007bff;
          color: white;
        }
      `}     
      </style>
      {!isAuthenticated ? (
        <div className="login-screen">
          <h2>Admin Login</h2>
          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button onClick={handleLogin}>Login</button>
        </div>
      ) : (
        <>
      <Header title="Admin Panel" />
      <div className="admin-panel">
        <h1 className="admin-title">Admin Panel</h1>
        <div className="tab-menu">
          <button
            className={activeTab === 'announcements' ? 'active' : ''}
            onClick={() => setActiveTab('announcements')}
          >
            Announcements
          </button>
          <button
            className={activeTab === 'events' ? 'active' : ''}
            onClick={() => setActiveTab('events')}
          >
            Events
          </button>
          <button
            className={activeTab === 'update' ? 'active' : ''}
            onClick={() => setActiveTab('update')}
          >
            Update Links
          </button>
          <button
            className={activeTab === 'enquiries' ? 'active' : ''}
            onClick={() => setActiveTab('enquiries') &&{fetchData}}
          >
            Enquiries
          </button>
          <button
                className={activeTab === 'achievers' ? 'active' : ''}
                onClick={() => setActiveTab('achievers')}
              >
                Achievers
              </button>
        </div>


        {activeTab === 'enquiries' && (
          <section>
            <table className="enquiry-table">
              <thead>
                <tr>
                  <th>Student Name</th>
                  <th>Date of Birth</th>
                  <th>Father's Name</th>
                  <th>Mother's Name</th>
                  <th>Class</th>
                  <th>Mobile Number</th>
                </tr>
              </thead>
              <tbody>
                {admissions.map((admission) => (
                  <tr key={admission._id}>
                    <td>{admission.studentName}</td>
                    <td>{new Date(admission.dateOfBirth).toLocaleDateString()}</td>
                    <td>{admission.fatherName}</td>
                    <td>{admission.motherName}</td>
                    <td>{admission.admittingClass}</td>
                    <td>{admission.mobileNumber}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        )}

        {activeTab === 'announcements' && (
          <section>
            <h2>Announcements</h2>
            <textarea
              placeholder="New announcement"
              value={newAnnouncement}
              onChange={(e) => setNewAnnouncement(e.target.value)}
            />
            <button onClick={handleAddAnnouncement}>Add</button>
            <div className="chips">
              {announcements.map((ann) => (
                <div key={ann._id} className="chip">
                  <span>{ann.text}</span>
                  <button onClick={() => handleDeleteAnnouncement(ann._id)}>Delete</button>
                </div>
              ))}
            </div>
          </section>
        )}

        {activeTab === 'events' && (
          <section>
            <h2>Upcoming Events</h2>
            <input
              type="text"
              placeholder="Event Description"
              value={newEvent.description}
              onChange={(e) => setNewEvent({ ...newEvent, description: e.target.value })}
            />
            <input
              type="date"
              value={newEvent.date}
              onChange={(e) => setNewEvent({ ...newEvent, date: e.target.value })}
            />
            <button onClick={handleAddEvent}>Add Event</button>
            <div className="chips">
              {events.map((event) => (
                <div key={event._id} className="chip">
                  <span>{event.description} - {new Date(event.date).toLocaleDateString()}</span>
                  <button onClick={() => handleDeleteEvent(event._id)}>Delete</button>
                </div>
              ))}
            </div>
          </section>
        )}

{activeTab === 'achievers' && (
              <section>
                <h2>Update Result Link</h2>
                <input
                  type="text"
                  placeholder="Result Link"
                  value={resultLink}
                  onChange={(e) => setResultLink(e.target.value)}
                />
                <button onClick={handleUpdateResultLink}>Update Link</button>
              </section>
            )}

        {activeTab === 'update' && (
          <section>
            <h2>Update Syllabus / Timetable Link</h2>
            <select
              value={updateData.type}
              onChange={(e) => setUpdateData({ ...updateData, type: e.target.value })}
            >
              <option value="">Select Type</option>
              <option value="syllabus">Syllabus</option>
              <option value="timetable">Timetable</option>
            </select>
            <input
              type="text"
              placeholder="Class"
              value={updateData.class}
              onChange={(e) => setUpdateData({ ...updateData, class: e.target.value })}
            />
            <input
              type="text"
              placeholder="Link"
              value={updateData.link}
              onChange={(e) => setUpdateData({ ...updateData, link: e.target.value })}
            />
            <button onClick={handleUpdateLink}>Update</button>
            {statusMessage && <p>{statusMessage}</p>}
          </section>
        )}
      </div>
      <Footer />
    </>
      )}
    </div>
  );
};

export default Admin;
